'use client';

import { useState } from 'react';
import TechIcon from './TechIcon';

interface TechStackProps {
    technologies: string[];
    maxVisible?: number;
    className?: string;
}

const TechStack = ({ technologies, maxVisible = 6, className = '' }: TechStackProps) => {
    const [showAll, setShowAll] = useState(false);

    const visibleTechnologies = showAll ? technologies : technologies.slice(0, maxVisible);
    const remainingCount = technologies.length - maxVisible;
    const hasMore = technologies.length > maxVisible;

    return (
        <div className={className}>
            <div className="flex flex-wrap gap-2 items-center justify-center">
                {visibleTechnologies.map((tech) => (
                    <TechIcon key={tech} tech={tech} />
                ))}

                {hasMore && !showAll && (
                    <button
                        onClick={() => setShowAll(true)}
                        className="px-2 py-1 bg-zinc-700 hover:bg-zinc-600 text-gray-300 hover:text-white text-xs rounded-md transition-colors border border-zinc-600"
                        title={`Show ${remainingCount} more technologies`}
                    >
                        +{remainingCount}
                    </button>
                )}

                {showAll && hasMore && (
                    <button
                        onClick={() => setShowAll(false)}
                        className="px-2 py-1 bg-zinc-700 hover:bg-zinc-600 text-gray-300 hover:text-white text-xs rounded-md transition-colors border border-zinc-600"
                        title="Show less"
                    >
                        Show less
                    </button>
                )}
            </div>
        </div>
    );
};

export default TechStack;